export default function StatCard({ label, value, hint, accent = "brand" }) {
  const accents = {
    brand: "text-brand-700",
    green: "text-green-700",
    amber: "text-amber-700",
    ink: "text-ink-700",
  };
  return (
    <div className="card p-5">
      <p className="text-sm font-medium text-ink-500">{label}</p>
      <p className={`mt-1 text-3xl font-semibold ${accents[accent]}`}>{value}</p>
      {hint && <p className="mt-1 text-xs text-ink-400">{hint}</p>}
    </div>
  );
}
